import mountReactApp from 'src/utils/mountReactApp'
import LiveDisplay from 'src/overlay/LiveDisplay'

mountReactApp(LiveDisplay)
